/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {ReferralSettingsApi } from '../api/referralSettings.api';
import { switchMap, map } from 'rxjs/operators';
import { ReferralSettings,ReferralSettingsData } from '../../../interfaces/masters/referralSettings';

@Injectable()
export class ReferralSettingsService extends ReferralSettingsData {

  constructor(private api: ReferralSettingsApi) {
    super();
  }


  list(url: string): Observable<ReferralSettings[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<ReferralSettings>{
      return this.api.getById(url);
  }

  create(url: string, data:ReferralSettings): Observable<ReferralSettings> {
    return this.api.add(url,data);
  }

  update(url: string, data:ReferralSettings): Observable<ReferralSettings> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
